const NS = 'MapBlock';
const CLS = 'mapBlock';
const BLK = '.' + CLS + '-';
/* global google*/
import {GoogleMapsApi} from 'global/js/googleMapsApi';

export class MapBlock {
	constructor($el) {
		this.$el = $el;
	}

	init() {
		let el = $(this.$el);
		let zoom = el.data('zoom');
		let latitude = el.data('latitude');
		let longitude = el.data('longitude');

		this.setMapBlock({
			zoom: zoom,
			latitude: latitude,
			longitude: longitude,
		});
		// this.setMarkers(this.geoLocationArray);
	}

	setMapBlock(params) {
		if(params.zoom && params.latitude && params.longitude) {
			// Add Some logic here
			const gmapApi = new GoogleMapsApi();
			gmapApi.load().then(() => {
				// safe to start using the API now
				let map = new google.maps.Map(document.querySelector(`#${CLS}-id`), {
					zoom: params.zoom,
					styles: gmapApi.styles,
					center: {
						lat: params.latitude,
						lng: params.longitude,
					},
					disableDefaultUI: true,
					scaleControl: true,
					zoomControl: true,
				});
				this.setMarkers(map, {
					latitude: params.latitude,
					longitude: params.longitude,
				});
			});
		}
	}

	setMarkers(map, params) {
		if(params.latitude && params.longitude) {
			// the zoom center coordinates should be {imgW/2, imgH} middle bottom of the pin image

			let pinMain = {
				// pinDefault is 36 x 54
				url: '/assets/images/map/pinMain.png',
				size: new google.maps.Size(36, 54),
				// scaled size of the pin icon
				// scaledSize: new google.maps.Size(18, 27),
				// The origin for this image is (0, 0).
				origin: new google.maps.Point(0, 0),
				// The anchor for this image is the base of the flagpole at (0, 32).
				anchor: new google.maps.Point(18, 54),
			};
			// load location marker into Google map
			let marker = new google.maps.Marker({
				position: {
					lat: params.latitude,
					lng: params.longitude,
				},
				map: map,
				icon: pinMain,
			});
		}
	}
}
